var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var isIconExist = function (iconFromConfig, AntdIcons) { return Boolean(iconFromConfig) && Boolean(AntdIcons[iconFromConfig]); };
export var replaceParamsWithValues = function (configPath, routeParams) {
    var paramKeys = Object.keys(routeParams || {});
    if (!routeParams || !paramKeys.length)
        return configPath;
    return paramKeys.reduce(function (acc, paramKey) { return acc.replace(":" + paramKey, routeParams[paramKey]); }, configPath);
};
export var getConfigFromPathname = function (path) {
    var pathArr = path.split('/');
    return pathArr.map(function (pathItem, index, arr) {
        var currentPath = arr.slice(0, index + 1).join('/');
        var currentItemConfig = { title: pathItem };
        var isLast = index === arr.length - 1;
        return { link: currentPath, config: currentItemConfig, isLast: isLast };
    });
};
export var getConfigFromRelevantRoutes = function (relevantRoutes, params) {
    return relevantRoutes.map(function (_a, index, arr) {
        var configPath = _a.path, rest = __rest(_a, ["path"]);
        var convertedPath = replaceParamsWithValues(configPath, params);
        var isLast = index === arr.length - 1;
        return { link: convertedPath, config: __assign({}, rest), isLast: isLast };
    });
};
export function getConfigForPath(path, params, config) {
    var relevantRoutes = config === null || config === void 0 ? void 0 : config.filter(function (_a) {
        var configPath = _a.path;
        var regexp = new RegExp("^" + configPath);
        return path.match(regexp);
    });
    return relevantRoutes
        ? getConfigFromRelevantRoutes(relevantRoutes, params)
        : getConfigFromPathname(path);
}
//# sourceMappingURL=helpers.js.map